import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../Config";
import { capitalizeFirstLetter, getLandlordTransactionFor, handleCopy, truncateText } from "../../helpers";
import moment from "moment";
import { getModeName } from "../../helpers";
import { MdOutlineChevronRight } from "react-icons/md";
import { IoCopySharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Tooltip from "../Tooltip";

const PaymentsTable = ({
  apiData,
  setSelectedData,
  setEditUser,
  setViewDetail,
  userType,
}) => {

  const navigate = useNavigate();
  useEffect(() => {
    setCurrentPage(0);
  }, [apiData]);

  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [previousId, setPreviousId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const viewDetail = (item) => {
    setViewDetail(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  // const ActionBtns = (item) => {
  //   return (
  //     <div className="flex gap-4 ">
  //       <button
  //         onClick={() => viewDetail(item)}
  //         className={`cursor-pointer text-sm px-4 py-1 rounded-lg ${' text-gray-600'} flex items-center gap-1`}
  //       >
  //         {/* Edit */}
  //         <MdOutlineChevronRight className="text-gray-300" size={24} />
  //       </button>
  //     </div>
  //   );
  // };

  const ActionBtns = (item) => (
    <Tooltip label="View details">
      <button
        onClick={() => viewDetail(item)}
        className="px-4 ml-auto text-gray-400 hover:text-gray-700 transition"
      >
        <MdOutlineChevronRight size={22} />
      </button>
    </Tooltip>
  );


  const goToSummary = (item) => {
    navigate(`/landlord/details`, {
      state: {
        landlordId: item?.paidTo,
      },
    });
  };
  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        room: item.roomNum,
        property: item?.propertyName ? truncateText(item.propertyName, 25) : "-",
        clientName: clientName(item),
        paidDate: <span className='text-gray-600 text-sm'>{moment(item.paidDate).format("DD, MMM YY")}</span>,
        amount: <Amount>{'₹' + item.amount}</Amount>,
        mode: getPaymentModeX(getModeName(item.mode)),
        transactionFor1: <span className="text-sm text-gray-600">{item.name}</span>,
        transactionFor: getDesc(item),
        transactionFor2: getLandlordTransactionFor(item),
        status: getStatus(item.status),
        //downloadReceipt: downloadReceipt(item),
        action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  const getDesc = (item) => (
    <span
      className="text-sm text-gray-600 line-clamp-2 max-w-[220px]"
      title={item?.description}
    >
      {item?.description ? truncateText(item.description, 40) : "-"}
    </span>
  );


  const getDescOld = (item) => {
    return (
      <div className="flex flex-col gap-1">
        {/* <span className="text-gray-600 text-sm font-medium">{item?.gId}</span> */}
        {/* <div className="flex gap-1">
          <span className="text-gray-600 text-sm font-medium">{item?.gId}</span>
          <button onClick={(e) => {
            e.stopPropagation();
            handleCopy(item?.gId);
          }}>
            <IoCopySharp size={10} className="text-gray-400" />
          </button>
        </div> */}
        <span
          // data-tooltip-id={`tooltip-${item.id}`}
          // data-tooltip-content={item.name}
          // data-tooltip-delay-show={200}
          // data-tooltip-delay-hide={100}
          // data-tooltip-place="top"
          // data-tooltip-variant="info"
          className="text-gray-600 text-sm"
        >
          {item?.description ? truncateText(item.description, 32) : "-"}
        </span>
        {/* <Tooltip id={`tooltip-${item.id}`} className="max-w-[70%] md:max-w-[50%] xl:max-w-[40%] 2xl:max-w-[20%]" /> */}
      </div>
    );
  };

  const getPaymentModeX = (mode, recordedBy) => {
    return (<div className="flex flex-col gap-0">
      <span className="text-gray-600 text-sm font-medium">
        {mode}{" "}
      </span>
      {/* {recordedBy && recordedBy === 'Kipinn App' ? <span className="text-primary-color text-sm">{"Recorded by " + recordedBy}</span>
        :
        <span className="text-gray-400 text-sm">{"Recorded by " + recordedBy}</span>
      } */}
    </div>);
  };

  const getName = (item) => {
    const name = capitalizeFirstLetter(item?.landlordName || "N/A");

    return (
      <UserImageWrapper
        className="cursor-pointer"
        onClick={() => goToSummary(item)}
      >
        <UserImage src={Images.Avatar} alt={name} />

        <div className="flex flex-col min-w-0">
          <span className="text-sm font-medium text-gray-800 truncate max-w-[180px]">
            {name}
          </span>

          <div className="flex items-center gap-1 text-xs text-gray-400">
            <span>#{item.landlordMobile}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.landlordMobile);
              }}
              className="hover:text-gray-600 transition"
              title="Copy number"
            >
              <IoCopySharp size={12} />
            </button>
          </div>
        </div>
      </UserImageWrapper>
    );
  };

  const getNameOld = (item) => {
    const name = capitalizeFirstLetter(item?.landlordName || 'N/A');
    return (
      <UserImageWrapper className="cursor-pointer"
        onClick={() => goToSummary(item)}
      >
        <UserImage src={Images.Avatar} alt={`Avatar for ${item.landlordName}`} />
        <div className="flex flex-col gap-1">
          <span className="text-gray-600 text-sm block max-w-[160px] break-words line-clamp-2">
            {truncateText(name, 35)}{" "}
          </span>
          {/* <span className="text-gray-400 text-xs">#{item.landlordMobile}</span> */}
          <div className="flex gap-1 items-center">
            <span className="text-gray-400 text-xs">#{item.landlordMobile}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.landlordMobile);
              }}
              className="p-1"
            >
              <IoCopySharp size={10} className="text-gray-400" />
            </button>
          </div>
        </div>
      </UserImageWrapper>
    );
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const clientName = (item) => {
    return (
      <div className="flex flex-col gap-[2px]">
        <p className="text-zinc-900 font-semibold">{item.clientName}</p>
        <p className="text-amber-500 text-xs">#{item.clientMobile}</p>
      </div>
    );
  };

  const getStatus = (status) => {
    if (status === 1) {
      return <Pending>Pending</Pending>;
    } else if (status === 2) {
      return <Resolve>SUCCESS</Resolve>;
    } else {
      return <Inprogress>FAILED</Inprogress>;
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Landlord",
          accessor: "name",
        },

        {
          Header: "Amount",
          accessor: "amount",
        },
      ];
    }
    return [
      {
        Header: "Landlord",
        accessor: "name",
      },
      {
        Header: "Property",
        accessor: "property",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        //Header: "TRANS ID/ Desc",
        Header: "For",
        accessor: "transactionFor2",
      },
      // {
      //   Header: "Mode",
      //   accessor: "mode",
      // },
      {
        Header: "Date",
        accessor: "paidDate",
      },
      {
        Header: "",
        accessor: "action",
      },
    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  // useEffect(() => {
  //   setPageSize(PaginationLimit);
  // }, []);

  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                        style={{ maxWidth: "320px" }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Category:</strong>{" "}
                          {data[rowIndex].transactionFor}
                        </li>
                        <li className="flex gap-2">
                          <strong>Mode:</strong> {data[rowIndex].mode}
                        </li>
                        <li className="flex gap-2">
                          <strong>Date:</strong> {data[rowIndex].paidDate}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-normal cursor-pointer hover:bg-gray-100`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
const UserImage = tw.img`w-9 h-9 rounded-full `;
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
// const ActionBtnWrapper = tw.div`grid xl:grid-cols-2 md:grid-cols-1 grid-cols-4 w-40 mb-1 gap-y-1 gap-x-1.5 md:w-16 mt-3 md:mt-0`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
// const Btn = tw.button`grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const Pending = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-24 h-7 flex items-center justify-center rounded`;
const Inprogress = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded`;
const Resolve = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded`;
//const Amount = tw.p`text-gray-600 text-sm bg-neutral-100 px-3 py-1 rounded-md inline-flex`
// const Amount = tw.p`
//   text-gray-900
//   text-sm
//   font-semibold
//   bg-emerald-50
//   text-emerald-700
//   px-3
//   py-1
//   rounded-full
//   inline-flex
//   whitespace-nowrap
// `;

const Amount = tw.p`
  text-gray-800 
  text-sm 
  font-semibold 
  bg-neutral-100 
  px-3 
  py-1 
  rounded-full 
  inline-flex 
  min-w-[80px]
  justify-center
`;

export default PaymentsTable;
